<template>
  <div>
    <div v-if="!isEmpty">
      <Timeline>
        <TimelineItem
          v-for="(item, index) in logisticsData"
          :key="index"
          v-bind="item"
        >
          <template #default="{ item }">
            <div class="logistics__container">
              <div class="logistics_wrapper">
                <div
                  v-if="item.type == 'D'"
                  class="img_view__container"
                  v-viewer="{ movable: true }"
                >
                  <div
                    v-for="(imgItem, index) in JSON.parse(item.content)"
                    :key="index"
                    class="img_wrapper"
                  >
                    <el-image
                      @click="onPreview"
                      :src="
                        imgItem.defaultImageUrl
                          ? $osscdn(imgItem.defaultImageUrl)
                          : '/image/static/img/nopic.jpg'
                      "
                      style="width: 160px; height: 100px"
                      fit="cover"
                    >
                      <div slot="error" class="image-slot">
                        <img
                          src="/image/static/img/nopic.jpg"
                          style="width: 160px; height: 100px"
                        />
                      </div>
                    </el-image>
                  </div>
                </div>
                <div v-else class="logistics_address_wrapper">
                  <span> {{ item.content || '' }}</span>
                </div>
              </div>
            </div>
          </template>
        </TimelineItem>
      </Timeline>
    </div>
    <div v-else class="not-data__container">
      <div style="text-align: center">
        <img src="/image/static/img/nodata.png" />
        <p class="no-data mt-2">
          {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import Timeline from './timeline/index.vue'
import TimelineItem from './timeline/item.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { Timeline, TimelineItem },
  props: {
    sendSampleCode: {
      type: String,
      default: '',
    },
  },
  mixins: [EditLoading],
  data() {
    return {
      logisticsData: [],
    }
  },
  computed: {
    isEmpty() {
      return !this.logisticsData || !this.logisticsData.length
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (this.loadingOpen()) return
      this.$api
        .customerSendSampleLogListApi({
          sendSampleCode: this.sendSampleCode,
        })
        .then((res) => {
          this.loadingClose()
          this.logisticsData = res?.body?.data || []
        })
        .catch(() => {
          this.loadingClose()
        })
    },

    onPreview(index) {
      const viewer = this.$el.querySelector('.img_view__container').$viewer
      viewer.view(index)
      viewer.show()
    },
  },
}
</script>

<style lang="scss" scoped>
.logistics__container {
  padding: 10px 0;
  .logistics_wrapper {
    border-radius: 5px;
    border: 1px dashed #bbbbbb;
    display: flex;
    > div {
      display: flex;
      flex-wrap: wrap;
      flex: 1;
      padding-top: 10px;
      .img_wrapper {
        padding: 0px 10px 5px;
        border-radius: 5px;
        > .el-image {
          border-radius: 5px;
        }
      }
    }
    .logistics_address_wrapper {
      padding: 10px 15px 20px;
      > span {
        font-size: 14px;
        color: #6c757d;
        height: 20px;
        line-height: 20px;
      }
    }
  }
}
</style>
